module.exports = __webpack_public_path__ + "img/06.a4469a1b.jpg";